import { ReactNode } from 'react';

import { AppFormattedMessage } from '../components/app-formatted-message/index';
import { StringKey } from '../lang/index';
import {
  CompanyAnnualRevenue,
  CompanyFilter,
  CompanyIndustry,
  CompanyNumberOfEmployees,
  CompanyType,
} from '../types/company.types';

export const companyTypeTranslation: Record<CompanyType, StringKey> = {
  [CompanyType.PRIVATE_EQUITY]: 'PRIVATE_EQUITY',
  [CompanyType.VENTURE_CAPITAL]: 'VENTURE_CAPITAL',
  [CompanyType.SPV]: 'SPV',
  [CompanyType.FAMILY_OFFICE]: 'FAMILY_OFFICE',
  [CompanyType.COMPANY]: 'COMPANY',
  [CompanyType.OTHER]: 'OTHER_FINANCIAL',
};

export const listOfCompanyTypeTranslation = Object.entries(companyTypeTranslation);

export const companyIndustryTranslation: Record<CompanyIndustry, StringKey> = {
  [CompanyIndustry.ESPORTS]: 'ESPORTS',
  [CompanyIndustry.AD_TECH]: 'AD_TECH',
  [CompanyIndustry.ACCOUNTING]: 'ACCOUNTING',
  [CompanyIndustry.AEROSPACE]: 'AEROSPACE',
  [CompanyIndustry.AGRICULTURE_FARMING]: 'AGRICULTURE_FARMING',
  [CompanyIndustry.ART]: 'ART',
  [CompanyIndustry.ARTIFICIAL_INTELLIGENCE]: 'ARTIFICIAL_INTELLIGENCE',
  [CompanyIndustry.AUTOMOTIVE]: 'AUTOMOTIVE',
  [CompanyIndustry.AVIATION]: 'AVIATION',
  [CompanyIndustry.AUDIT]: 'AUDIT',
  [CompanyIndustry.BANKING_FINANCIAL_SERVICES]: 'BANKING_FINANCIAL_SERVICES',
  [CompanyIndustry.BIOTECHNOLOGY]: 'BIOTECHNOLOGY',
  [CompanyIndustry.BUILDING_MATERIALS_SUPPLIES]: 'BUILDING_MATERIALS_SUPPLIES',
  [CompanyIndustry.BUSINESS_SERVICES]: 'BUSINESS_SERVICES',
  [CompanyIndustry.CHEMICAL_INDUSTRY]: 'CHEMICAL_INDUSTRY',
  [CompanyIndustry.CLEANING_PRODUCTS_SERVICES]: 'CLEANING_PRODUCTS_SERVICES',
  [CompanyIndustry.CLOUD_COMPUTING]: 'CLOUD_COMPUTING',
  [CompanyIndustry.COMPUTER_HARDWARE]: 'COMPUTER_HARDWARE',
  [CompanyIndustry.CONSTRUCTION]: 'CONSTRUCTION',
  [CompanyIndustry.CONSULTING]: 'CONSULTING',
  [CompanyIndustry.CONSUMER_ELECTRONICS]: 'CONSUMER_ELECTRONICS',
  [CompanyIndustry.CONSUMER_GOODS]: 'CONSUMER_GOODS',
  [CompanyIndustry.CONSUMER_HEALTHCARE]: 'CONSUMER_HEALTHCARE',
  [CompanyIndustry.CULTURE]: 'CULTURE',
  [CompanyIndustry.CYBERSECURITY]: 'CYBERSECURITY',
  [CompanyIndustry.DATA_ANALYTICS]: 'DATA_ANALYTICS',
  [CompanyIndustry.DATA_STORAGE_MANAGEMENT]: 'DATA_STORAGE_MANAGEMENT',
  [CompanyIndustry.DEFENSE]: 'DEFENSE',
  [CompanyIndustry.E_COMMERCE]: 'ECOMMERCE',
  [CompanyIndustry.ED_TECH]: 'ED_TECH',
  [CompanyIndustry.EDUCATION_TRAINING]: 'EDUCATION_TRAINING',
  [CompanyIndustry.ELECTRIC_VEHICLES]: 'ELECTRIC_VEHICLES',
  [CompanyIndustry.ENERGY]: 'ENERGY',
  [CompanyIndustry.ENTERTAINMENT]: 'ENTERTAINMENT',
  [CompanyIndustry.ENVIRONMENTAL_SERVICES]: 'ENVIRONMENTAL_SERVICES',
  [CompanyIndustry.EVENTS]: 'EVENTS',
  [CompanyIndustry.FABRICS_TEXTILES]: 'FABRICS_TEXTILES',
  [CompanyIndustry.FASHION]: 'FASHION',
  [CompanyIndustry.FINTECH]: 'FINTECH',
  [CompanyIndustry.FOOD_BEVERAGES]: 'FOOD_BEVERAGES',
  [CompanyIndustry.GOVERNMENT_PUBLIC_INSTITUTIONS]: 'GOVERNMENT_PUBLIC_INSTITUTIONS',
  [CompanyIndustry.HEALTHCARE]: 'HEALTHCARE',
  [CompanyIndustry.HOSPITALITY]: 'HOSPITALITY',
  [CompanyIndustry.HR_TECH]: 'HR_TECH',
  [CompanyIndustry.IGAMING]: 'IGAMING',
  [CompanyIndustry.INFORMATION_TECHNOLOGIES]: 'INFORMATION_TECHNOLOGIES',
  [CompanyIndustry.INSURANCE]: 'INSURANCE',
  [CompanyIndustry.INTERNET_OF_THINGS]: 'INTERNET_OF_THINGS',
  [CompanyIndustry.LEGAL]: 'LEGAL',
  [CompanyIndustry.LEGAL_COMPLIANCE]: 'LEGAL_COMPLIANCE',
  [CompanyIndustry.LEISURE_RECREATION]: 'LEISURE_RECREATION',
  [CompanyIndustry.LOGISTICS_SUPPLY_CHAIN]: 'LOGISTICS_SUPPLY_CHAIN',
  [CompanyIndustry.LUXURY_GOODS]: 'LUXURY_GOODS',
  [CompanyIndustry.MACHINERY_HEAVY_EQUIPMENT]: 'MACHINERY_HEAVY_EQUIPMENT',
  [CompanyIndustry.MANUFACTURING]: 'MANUFACTURING',
  [CompanyIndustry.MARKETING_ADVERTISING]: 'MARKETING_ADVERTISING',
  [CompanyIndustry.MEDIA]: 'MEDIA',
  [CompanyIndustry.MEDICAL_DEVICES_SUPPLIES]: 'MEDICAL_DEVICES_SUPPLIES',
  [CompanyIndustry.MINING]: 'MINING',
  [CompanyIndustry.MOBILITY_TRANSPORTATION]: 'MOBILITY_TRANSPORTATION',
  [CompanyIndustry.MUSIC]: 'MUSIC',
  [CompanyIndustry.NON_PROFIT]: 'NON_PROFIT',
  [CompanyIndustry.PERSONAL_SERVICES]: 'PERSONAL_SERVICES',
  [CompanyIndustry.PET_CARE_SUPPLIES]: 'PET_CARE_SUPPLIES',
  [CompanyIndustry.PHARMACEUTICALS]: 'PHARMACEUTICALS',
  [CompanyIndustry.PROFESSIONAL_SERVICES]: 'PROFESSIONAL_SERVICES',
  [CompanyIndustry.PUBLISHING]: 'PUBLISHING',
  [CompanyIndustry.REAL_ESTATE_PROPTECH]: 'REAL_ESTATE_PROPTECH',
  [CompanyIndustry.RESTAURANTS_FOOD_SERVICES]: 'RESTAURANTS_FOOD_SERVICES',
  [CompanyIndustry.RETAIL]: 'RETAIL',
  [CompanyIndustry.ROBOTICS]: 'ROBOTICS',
  [CompanyIndustry.SMART_CITY]: 'SMART_CITY',
  [CompanyIndustry.SOCIAL_MEDIA]: 'SOCIAL_MEDIA',
  [CompanyIndustry.SOFTWARE_DEVELOPMENT]: 'SOFTWARE_DEVELOPMENT',
  [CompanyIndustry.SPORTS_FITNESS]: 'SPORTS_FITNESS',
  [CompanyIndustry.TELECOM_CONNECTIVITY]: 'TELECOM_CONNECTIVITY',
  [CompanyIndustry.TAX]: 'TAX',
  [CompanyIndustry.TRAVEL_TOURISM]: 'TRAVEL_TOURISM',
  [CompanyIndustry.VIDEO_GAMES]: 'VIDEO_GAMES',
  [CompanyIndustry.WASTE_MANAGEMENT]: 'WASTE_MANAGEMENT',
  [CompanyIndustry.OTHER]: 'OTHER',
};

export const companyIndustryMap = Object.keys(companyIndustryTranslation);

export const listOfCompanyIndustryTranslation = Object.entries(companyIndustryTranslation);

export const companyAnnualRevenueTranslation: Record<CompanyAnnualRevenue, ReactNode> = {
  [CompanyAnnualRevenue.NO_REV]: <AppFormattedMessage id="NO_REV" />,
  [CompanyAnnualRevenue.LESS_1_MIL]: (
    <>
      $0 <AppFormattedMessage id="BETWEEN_SYMBOL" /> $1M
    </>
  ),
  [CompanyAnnualRevenue.BETWEEN_1_5_MIL]: (
    <>
      $1M <AppFormattedMessage id="BETWEEN_SYMBOL" /> $5M
    </>
  ),
  [CompanyAnnualRevenue.BETWEEN_5_20_MIL]: (
    <>
      $5M <AppFormattedMessage id="BETWEEN_SYMBOL" /> $20M
    </>
  ),

  [CompanyAnnualRevenue.MORE_20_MIL]: '>$20M',
};

export const listOfCompanyAnnualRevenueTranslation = Object.entries(
  companyAnnualRevenueTranslation,
) as [CompanyAnnualRevenue, string][];

export const companyNumberOfEmployeesTranslation: Record<CompanyNumberOfEmployees, ReactNode> = {
  [CompanyNumberOfEmployees.BETWEEN_1_10]: (
    <>
      1 <AppFormattedMessage id="BETWEEN_SYMBOL" /> 10
    </>
  ),
  [CompanyNumberOfEmployees.BETWEEN_11_25]: (
    <>
      11 <AppFormattedMessage id="BETWEEN_SYMBOL" /> 25
    </>
  ),
  [CompanyNumberOfEmployees.BETWEEN_26_50]: (
    <>
      26 <AppFormattedMessage id="BETWEEN_SYMBOL" /> 50
    </>
  ),
  [CompanyNumberOfEmployees.BETWEEN_51_250]: (
    <>
      51 <AppFormattedMessage id="BETWEEN_SYMBOL" /> 250
    </>
  ),
  [CompanyNumberOfEmployees.MORE_250]: '>250',
};

export const listOfCompanyNumberOfEmployeesTranslation = Object.entries(
  companyNumberOfEmployeesTranslation,
) as [CompanyNumberOfEmployees, string][];

export const companyFilterTranslation: Record<CompanyFilter, ReactNode> = {
  [CompanyFilter.ACTIVE]: <AppFormattedMessage id="ACTIVE" />,
  [CompanyFilter.INACTIVE]: <AppFormattedMessage id="INACTIVE" />,
};
export const listOfCompanyFilter = Object.entries(companyFilterTranslation) as [
  CompanyFilter,
  string,
][];

export enum CompanySettingsCardVariant {
  COMPANY_ADDRESS = 'address',
  COMPANY_DETAILS = 'details',
  COMPANY_PLAN_BILLING = 'plan-billing',
}

export const CompanySettingsCardTranslation: Record<CompanySettingsCardVariant, ReactNode> = {
  [CompanySettingsCardVariant.COMPANY_DETAILS]: <AppFormattedMessage id="DETAILS" />,
  [CompanySettingsCardVariant.COMPANY_ADDRESS]: <AppFormattedMessage id="ADDRESS" />,
  [CompanySettingsCardVariant.COMPANY_PLAN_BILLING]: <AppFormattedMessage id="PLAN_BILLING" />,
};

export const arrayOfCompanySettingsCardTranslation = Object.entries(
  CompanySettingsCardTranslation,
) as [CompanySettingsCardVariant, string][];
